import { render, staticRenderFns } from "./ai_cascader.vue?vue&type=template&id=59d58a22&scoped=true"
import script from "./ai_cascader.vue?vue&type=script&lang=js"
export * from "./ai_cascader.vue?vue&type=script&lang=js"
import style0 from "./ai_cascader.vue?vue&type=style&index=0&id=59d58a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d58a22",
  null
  
)

export default component.exports